// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 954 ? "eb6e03f4" : chunkId) + "." + {"894":"e64c37aa3333875b","917":"86a11b3524f8ad1b","954":"580c75cc67e724d0"}[chunkId] + ".js";
};